import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwCacheService, SuppressErrorMessagesHeader } from "@devwareapps/devware-cap";
import { AirportEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";
import { CheckrideReferenceInfo } from "../../examiner/models/checkride-reschedule-info.model";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AirportMetar } from "../../examiner/models/airport-metar.model";
import { WeatherBasicMetarDTO } from "../../examiner/models/weather-basic-metar.model";

@Injectable({ providedIn: 'root' })
export class MetarRepositoryService {
    apiRoot: string;

    constructor(
        private http: HttpClient,
        @Inject(DwConfigServiceToken) configService: DwConfigService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,
    ) {
        this.apiRoot = configService.coreConfig.apiRoot;
    }

    getAirportMetars(airports: AirportEntity[]): Observable<AirportMetar[]> {
        const apiParams = airports.map(airport => `${airport.AirportCode}`).join(',');
        const url = `${this.apiRoot}/pilexos/weather/airports/metars?airportCodes=${apiParams}`;

        let headers = new HttpHeaders();

        headers = headers.append(SuppressErrorMessagesHeader, 'true');

        return this.http.get<WeatherBasicMetarDTO[]>(url, { headers: headers })
            .pipe(map((serverMetars) => {
                const metars: AirportMetar[] = [];

                for (var metar of serverMetars) {
                    var airport = airports.find(a => a.AirportCode == metar.AirportCode);

                    metars.push({
                        airport: airport,
                        metar: metar.Metar
                    });
                }
                return metars;
            }),
                catchError(err => {
                    console.error('Error loading Metar data', err);

                    return of([]);
                }));
    }


}